export const en: Record<string, string> = {
  "contracts.detail.back": "Back to contracts",
  "contracts.detail.sections": "Contract sections",
  "contracts.detail.overview": "Overview",
  "contracts.detail.work": "Work & updates",
  "contracts.detail.payment": "Payments",
  "contracts.detail.documents": "Documents",
  "contracts.detail.close": "Close",
  "contracts.detail.value": "Contract value",
  "contracts.detail.message": "Message",
  "contracts.detail.released": "Released",
  "contracts.detail.escrow": "Held in escrow",
  "contracts.detail.contractPdf": "Contract PDF",
  "contracts.detail.receiptPdf": "Receipt PDF",
  "contracts.detail.role": "Your role",
  "contracts.detail.created": "Created",
  "contracts.detail.client": "Client",
  "contracts.detail.contractor": "Contractor",
  "contracts.detail.provider": "Provider",
  "contracts.detail.seller": "Seller",
  "contracts.detail.buyer": "Buyer",
  "contracts.detail.project": "Project bidding",
  "contracts.detail.service": "Service",
  "contracts.detail.order": "Purchase",
  "contracts.detail.hire": "Direct hire",
  "contracts.detail.rfq": "RFQ",
  "contracts.detail.agreement": "Agreement",
  "contracts.detail.scope": "Scope & terms",
  "contracts.detail.agreedCompletion": "Agreed completion",
  "contracts.detail.proposedCompletion": "Proposed completion",
  "contracts.detail.workLocked": "Work updates unlock after escrow is funded. Existing records remain available to read.",
  "contracts.detail.logs": "Time & progress",
  "contracts.detail.checklist": "Checklist & check-ins",
  "contracts.detail.process": "Contract process",
  "contracts.detail.processEnded": "This contract has ended. The remaining steps no longer apply.",
  "contracts.detail.steps.awarded": "Bid awarded",
  "contracts.detail.steps.quoteAccepted": "Quote accepted",
  "contracts.detail.steps.quoteAwarded": "Quote awarded",
  "contracts.detail.steps.contractorSigns": "Contractor signs",
  "contracts.detail.steps.providerSigns": "Provider signs",
  "contracts.detail.steps.acceptSign": "Accept & sign",
  "contracts.detail.steps.signAgreement": "Sign agreement",
  "contracts.detail.steps.clientSigns": "Client signs",
  "contracts.detail.steps.fundEscrow": "Fund escrow",
  "contracts.detail.steps.escrowFunding": "Escrow funding",
  "contracts.detail.steps.escrowFunded": "Escrow funded",
  "contracts.detail.steps.reviewRelease": "Review & release",
  "contracts.detail.steps.completeWork": "Complete work",
  "contracts.detail.steps.complete": "Complete",
  "contracts.detail.steps.supplierAccepts": "Supplier accepts",
  "contracts.detail.steps.acceptOffer": "Accept offer",
  "contracts.detail.steps.orderPaid": "Order paid",
  "contracts.detail.steps.buyerPaid": "Buyer paid",
  "contracts.detail.steps.confirmReceipt": "Confirm receipt",
  "contracts.detail.steps.fulfillOrder": "Fulfill order",
  "contracts.detail.steps.orderComplete": "Order complete",
  "contracts.detail.steps.offerSent": "Offer sent",
  "contracts.detail.steps.offerReceived": "Offer received",
  "contracts.detail.steps.providerAccepts": "Provider accepts",
  "contracts.detail.steps.agreementCreated": "Agreement created",
  "contracts.filter.all": "All",
  "contracts.filter.offer": "Offer pending",
  "contracts.filter.signature": "Pending signature",
  "contracts.filter.funding": "Pending funding",
  "contracts.filter.active": "In progress",
  "contracts.search": "Search contract or person",
  "contracts.mobile.stage": "Stage",
  "contracts.mobile.search": "Search contract or person",
  "contracts.mobile.offer": "Pending offer",
  "contracts.mobile.signature": "To sign",
  "contracts.mobile.funding": "To fund",
  "contracts.mobile.active": "Active",
  "contracts.mobile.completed": "Completed",
  "contracts.mobile.cancelled": "Cancelled",
  "contracts.mobile.buyer": "Buyer",
  "contracts.mobile.provider": "Provider",
  "contracts.mobile.paid": "Paid",
  "contracts.mobile.clearSearch": "Clear search",
  "contracts.mobile.noMatch": "No contracts match this stage or search.",
  "contracts.mobile.empty": "No contracts yet. Awarded projects, accepted quotes, and service or hiring agreements appear here.",
};

export const tl: Record<string, string> = {
  "contracts.detail.back": "Bumalik sa kontrata",
  "contracts.detail.sections": "Mga bahagi ng kontrata",
  "contracts.detail.overview": "Buod",
  "contracts.detail.work": "Trabaho",
  "contracts.detail.payment": "Mga bayad",
  "contracts.detail.documents": "Mga dokumento",
  "contracts.detail.close": "Isara",
  "contracts.detail.value": "Halaga ng kontrata",
  "contracts.detail.message": "Mensahe",
  "contracts.detail.released": "Naibayad",
  "contracts.detail.escrow": "Nasa escrow",
  "contracts.detail.contractPdf": "Kontrata PDF",
  "contracts.detail.receiptPdf": "Resibo PDF",
  "contracts.detail.role": "Iyong papel",
  "contracts.detail.created": "Ginawa",
  "contracts.detail.client": "Kliyente",
  "contracts.detail.contractor": "Kontratista",
  "contracts.detail.provider": "Provider",
  "contracts.detail.seller": "Nagbebenta",
  "contracts.detail.buyer": "Mamimili",
  "contracts.detail.project": "Project bidding",
  "contracts.detail.service": "Serbisyo",
  "contracts.detail.order": "Binili",
  "contracts.detail.hire": "Direktang hire",
  "contracts.detail.rfq": "RFQ",
  "contracts.detail.agreement": "Kasunduan",
  "contracts.detail.scope": "Saklaw at tuntunin",
  "contracts.detail.agreedCompletion": "Napagkasunduang pagtatapos",
  "contracts.detail.proposedCompletion": "Iminungkahing pagtatapos",
  "contracts.detail.workLocked": "Maaaring mag-ulat kapag napondohan na ang escrow. Mababasa pa rin ang dating mga tala.",
  "contracts.detail.logs": "Oras at mga ulat",
  "contracts.detail.checklist": "Checklist at mga ulat",
  "contracts.detail.process": "Proseso ng kontrata",
  "contracts.detail.processEnded": "Natapos na ang kontratang ito. Hindi na naaangkop ang mga susunod na hakbang.",
  "contracts.detail.steps.awarded": "Napiling bid",
  "contracts.detail.steps.quoteAccepted": "Tinanggap ang quote",
  "contracts.detail.steps.quoteAwarded": "Napiling quote",
  "contracts.detail.steps.contractorSigns": "Pirma ng kontratista",
  "contracts.detail.steps.providerSigns": "Pirma ng provider",
  "contracts.detail.steps.acceptSign": "Tanggapin at pumirma",
  "contracts.detail.steps.signAgreement": "Pirmahan ang kasunduan",
  "contracts.detail.steps.clientSigns": "Pirma ng kliyente",
  "contracts.detail.steps.fundEscrow": "Pondohan ang escrow",
  "contracts.detail.steps.escrowFunding": "Pagpopondo ng escrow",
  "contracts.detail.steps.escrowFunded": "May pondo na ang escrow",
  "contracts.detail.steps.reviewRelease": "Suriin at ibayad",
  "contracts.detail.steps.completeWork": "Tapusin ang trabaho",
  "contracts.detail.steps.complete": "Tapos na",
  "contracts.detail.steps.supplierAccepts": "Pagtanggap ng supplier",
  "contracts.detail.steps.acceptOffer": "Tanggapin ang alok",
  "contracts.detail.steps.orderPaid": "Bayad na ang order",
  "contracts.detail.steps.buyerPaid": "Bayad na ang mamimili",
  "contracts.detail.steps.confirmReceipt": "Kumpirmahing natanggap",
  "contracts.detail.steps.fulfillOrder": "Ihatid ang order",
  "contracts.detail.steps.orderComplete": "Tapos na ang order",
  "contracts.detail.steps.offerSent": "Naipadala ang alok",
  "contracts.detail.steps.offerReceived": "Natanggap ang alok",
  "contracts.detail.steps.providerAccepts": "Pagtanggap ng provider",
  "contracts.detail.steps.agreementCreated": "Nagawa ang kasunduan",
  "contracts.filter.all": "Lahat",
  "contracts.filter.offer": "Naghihintay ang Alok",
  "contracts.filter.signature": "Naghihintay ng Lagda",
  "contracts.filter.funding": "Naghihintay ng Pondo",
  "contracts.filter.active": "Isinasagawa",
  "contracts.search": "Maghanap ng kontrata o tao",
  "contracts.mobile.stage": "Yugto",
  "contracts.mobile.search": "Kontrata o tao",
  "contracts.mobile.offer": "May alok",
  "contracts.mobile.signature": "Pipirmahan",
  "contracts.mobile.funding": "Popondohan",
  "contracts.mobile.active": "Aktibo",
  "contracts.mobile.completed": "Tapos na",
  "contracts.mobile.cancelled": "Kinansela",
  "contracts.mobile.buyer": "Kliyente",
  "contracts.mobile.provider": "Provider",
  "contracts.mobile.paid": "Bayad na",
  "contracts.mobile.clearSearch": "Alisin ang hanap",
  "contracts.mobile.noMatch": "Walang kontratang tugma sa yugto o hanap.",
  "contracts.mobile.empty": "Wala pang kontrata. Dito makikita ang mga kasunduan sa proyekto, quote, serbisyo, o hiring.",
};
